import React from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";

const FaqOne = (props) => {
  const { itemClass, items } = props;

  return (
    <div
      className={
        itemClass
          ? itemClass
          : "it-custom-accordion it-custom-accordion-style-2"
      }
    >
      <Accordion className="accordion" preExpanded={["a"]} allowZeroExpanded>
        {items.map((item) => (
          <AccordionItem
            key={item.id}
            className="accordion-items"
            uuid={item.id}
          >
            <AccordionItemHeading className="accordion-header">
              <AccordionItemButton
                className="accordion-buttons"
                style={{ color: "white" }}
              >
                {item.btnText}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="accordion-body">
                <div className="it-wrok-area it-wrok-bg pt-10 pb-0">
                  <div className="container">
                    <div className="row">
                      {item.description.map((member, idx) => (
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-20 wow"
                          data-wow-duration=".9s"
                          data-wow-delay=".3s"
                          key={idx}
                        >
                          <div className="it-work-item text-start">
                            <div className="it-work-content">
                              <h4 className="it-work-title-sm">
                                <Link to="">{member.name}</Link>
                              </h4>
                              <p className="it-work-title-xs">
                                {member.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
export default FaqOne;
